import { useEffect, useState } from "react";

export function useDocumentTitle() {
    const [title, setTitle] = useState(() => document.title);

    useEffect(() => {
        const updateTitle = () => setTitle(document.title);

        let titleElement = document.querySelector("title");

        const observer = new MutationObserver(() => {
            updateTitle();

            // If <title> is replaced, re-select and observe it
            const newTitleElement = document.querySelector("title");
            if (newTitleElement !== titleElement) {
                if (titleObserver) titleObserver.disconnect();
                titleElement = newTitleElement;
                if (titleElement) {
                    titleObserver.observe(titleElement, { childList: true });
                }
            }
        });

        const titleObserver = new MutationObserver(updateTitle);

        // Observe <head> for changes, including <title> being replaced
        observer.observe(document.head, {
            childList: true,
            subtree: true,
        });

        // Also observe the current <title> content
        if (titleElement) {
            titleObserver.observe(titleElement, { childList: true });
        }

        return () => {
            observer.disconnect();
            titleObserver.disconnect();
        };
    }, []);

    return title;
}
